<template>
  <div>
    当班管理
  </div>
</template>

<script>
export default {
  name: "whenClass"
}
</script>

<style scoped>

</style>
